import { render, staticRenderFns } from "./viewSelfHelp.vue?vue&type=template&id=45bdac0a"
import script from "./viewSelfHelp.vue?vue&type=script&lang=js"
export * from "./viewSelfHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports